module.exports = __webpack_public_path__ + "img/bg_about.ba3f96ba.jpg";